import {getConfig} from '../../services/config/configService';

const getLocalizations = () => getConfig()?.marketLocalizations;

const getMarketLocalization = (market) =>
    getLocalizations()?.find((marketLocalization) => marketLocalization.market === market);

const getIsMarketSupported = (countryCode) => {
    const isMarketSupported = getLocalizations().some(
        (marketLocalization) => marketLocalization.market === countryCode
    );

    return isMarketSupported;
};

const getLocalizationFileNameIfItSupported = (countryCode, languageCode) => {
    const marketLocalization = getMarketLocalization(countryCode);

    const languageData = marketLocalization?.languages?.find((languageData) => languageData?.language === languageCode);

    if (languageData) {
        return languageData?.name;
    }

    return null;
};

const getMarketLanguages = (countryCode) => {
    const marketLocalization = getMarketLocalization(countryCode);

    return marketLocalization?.languages;
};

const getMarketDefaultLanguageData = (countryCode) => {
    const marketLanguages = getMarketLanguages(countryCode);

    return marketLanguages?.find((language) => language.isDefault);
};

const getMarketDefaultLocalizationName = (countryCode) => {
    const defaultLanguageData = getMarketDefaultLanguageData(countryCode);

    return defaultLanguageData?.name;
};

const getDefaultLanguageCode = (countryCode) => {
    const marketDefaultLanguageData = getMarketDefaultLanguageData(countryCode);

    return marketDefaultLanguageData?.language;
};

const configLocalizationGetters = {
    getLocalizations,
    getMarketLanguages,
    getIsMarketSupported,
    getMarketLocalization,
    getDefaultLanguageCode,
    getMarketDefaultLanguageData,
    getMarketDefaultLocalizationName,
    getLocalizationFileNameIfItSupported,
};

export default configLocalizationGetters;
